// プラン
export const plan = [
  { value: 10, text: "10プラン" },
  { value: 50, text: "50プラン" },
  { value: 100, text: "100プラン" },
  { value: 150, text: "150プラン" },
  { value: 200, text: "200プラン" },
  { value: 250, text: "250プラン" },
  { value: 300, text: "300プラン" },
];

// 支払区分
/*--- 2026.02.04 MCS)TEZUKA 「2:会社負担」,「3:派遣会社請求」,「9:その他」追加 ---*/
// [V2.2] 「2:会社負担」を廃止（会社負担は雇用形態マスタの会社負担設定で管理）
// [V2.2] 2026.07.07 「2:会社負担」を復活（来客用ユーザーが支払区分2で登録済みのため）
export const c_paykbn = [
  { value: 0, text: "現金" },
  { value: 1, text: "給与控除" },
  /*-- 2026.07.07 V2.2 AI ADD START --*/
  { value: 2, text: "会社負担" },
  /*-- 2026.07.07 V2.2 AI ADD END --*/
  { value: 3, text: "派遣会社請求" },
  { value: 9, text: "その他" },
];
